var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Dashboard") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "02-RHQMS",
    transform: "translate(-140.000000, -38.000000)",
    stroke: "#6C3964",
    strokeWidth: 1.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M150.15,51.85 L150.15,61.35 L140.65,61.35 L140.65,51.85 L150.15,51.85 Z M163.35,51.85 L163.35,61.35 L153.85,61.35 L153.85,51.85 L163.35,51.85 Z M150.15,38.65 L150.15,48.15 L140.65,48.15 L140.65,38.65 L150.15,38.65 Z M163.35,38.65 L163.35,48.15 L153.85,48.15 L153.85,38.65 L163.35,38.65 Z",
    id: "Dashboard"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/Dashboard.738fd1b99419b2554164e0504cd9bc00.svg";
export { ForwardRef as ReactComponent };